import Endpoint from './endpoint'
import { API_URL } from './index'

export default class Filters extends Endpoint {
  async all() {
    let url = new URL('/api/filters', API_URL)

    return this.request(url)
  }
  async allContactFilters() {
    let url = new URL('/api/contactFilters', API_URL)

    return this.request(url)
  }
  async allLeadFilters() {
    let url = new URL('/api/leadFilters', API_URL)
    return this.request(url)
  }
}
